import { lazy, useMemo } from 'react';
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from '@stripe/stripe-js';
import { useBranding } from '../../contexts/brandingContext';
import { publishableKey } from '../../services/api/config';
const Dashboard = lazy(() => import('../../pages/dashboard'));
const Profile = lazy(() => import('../../pages/profile/profile'));
const LoginForm = lazy(() => import('../../pages/auth/Login/Login'));
const ForgotPassword = lazy(() => import('../../pages/auth/ForgotPassword/ForgotPassword'));
const ResetPassword = lazy(() => import('../../pages/auth/ResetPassword/ResetPassword'));
const TwoFactorLoginForm = lazy(() => import('../../pages/auth/TwoFactorLogin/TwoFactorLogin'));
const SignUp = lazy(() => import('../../pages/auth/SignUp/SignUp'));
const OrderHistory = lazy(() => import('../../pages/order/orderHistory'));
const PaymentHistory = lazy(() => import('../../pages/payment/paymentHistory'))
const OrderDetail = lazy(() => import('../../pages/order/orderDetail'));
const CreateOrder = lazy(() => import('../../pages/order/createOrder'));
const PaymentMethod = lazy(() => import('../../pages/payment/paymentMethod'));


const PaymentMethodWrapper = () => {
  const { connectedAccountId } = useBranding();
  const stripePromise = useMemo(() => {
    if (!connectedAccountId) return null;
    return loadStripe(publishableKey, { stripeAccount: connectedAccountId });
  }, [connectedAccountId]);

  return (
    <Elements stripe={stripePromise}>
      <PaymentMethod />
    </Elements>
  );
};

export const PUBLIC_ROUTES = [
  { path: "/", element: LoginForm },
  { path: "/forgotPassword", element: ForgotPassword },
  { path: "/resetPassword", element: ResetPassword },
  { path: "/twoFactorLogin", element: TwoFactorLoginForm },
  { path: "/signIn", element: SignUp }
];

export const PROTECTED_ROUTES = [
  { path: "/dashboard", element: Dashboard },
  { path: "/profile", element: Profile },
  { path: "/invoices", element: OrderHistory },
  { path: "/paymentHistory", element: PaymentHistory },
  { path: "/invoice-detail", element: OrderDetail },
  { path: "/add-invoice", element: CreateOrder },
  { path: "/update-invoice", element: CreateOrder },
  { path: "/paymentMethods", element: PaymentMethodWrapper },
];